import { ReactNode } from "react";

import { css, styled } from "@mui/material";

import { getColor } from "@hooks";
import { cssPropertiesToString } from "@utils";

interface ContentCardProps {
  children: ReactNode;
}

const ContentCardStyled = styled("div")(
  ({ theme }) => css`
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p {
      background-color: ${theme.palette.mode === "dark"
        ? "#222530"
        : "#fcfcfc"};

      box-shadow:
        0px 10px 22px -2.5px #00000008,
        0px 2.29px 5.03px -1.67px #00000008,
        0px 0.6px 1.32px -0.83px #00000008;

      box-shadow:
        0px 10px 22px -2.5px ${theme.palette.mode === "dark" ? "#FFFFFF08" : "#00000008"},
        0px 2.29px 5.03px -1.67px ${theme.palette.mode === "dark" ? "#FFFFFF08" : "#00000008"},
        0px 0.6px 1.32px -0.83px ${theme.palette.mode === "dark" ? "#FFFFFF08" : "#00000008"};

      padding: 16px 48px;
      border-radius: 0;
      overflow: hidden;
      margin-block-end: 0;
      margin-bottom: 0 !important;

      :first-child {
        background-image: linear-gradient(
          to right,
          #ffffff00 50%,
          ${getColor(c => c.tokens.stroke["sub-300"], theme)} 0%
        );
        background-position: bottom;
        background-size: 15px 1px;
        background-repeat: repeat-x;
        border-radius: 20px;
        padding: 32px 48px;
      }

      :nth-child(2) {
        border-radius: 20px 20px 0 0;
        padding: 32px 48px 16px 48px;
      }

      :last-child {
        border-radius: 0 0 20px 20px;
        padding: 16px 48px 32px 48px;
      }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      ${cssPropertiesToString(theme.typography.paragraph_xxlarge_semibold)};
      text-align: center;
    }

    p {
      ${cssPropertiesToString(theme.typography.paragraph_large_regular)}
    }
  `,
);

export const ContentCard = ({ children }: ContentCardProps) => {
  return <ContentCardStyled>{children}</ContentCardStyled>;
};
